import { __assign } from "tslib";
// DS: C37D
import React from 'react';
import DeviationBlockedFullView from './DeviationBlocked';
import ArtistBlockedFullView from './ArtistBlocked';
import DefaultBlockedFullView from './DefaultBlocked';
import AntisocialBlockedFullView from './AntisocialBlocked';
import { BlockReasons } from '../../../Moderation/redux/types';
import MatureAnonymousBlockedFullView from './MatureAnonymousBlocked';
import MatureBlockedFullView from './MatureBlocked';
import MatureAgeBlockedFullView from './MatureAgeBlocked';
import MatureStrictBlockedFullView from './MatureStrictBlocked';
var BlockedFullView = function (props) {
    switch (props.blockReason) {
        case BlockReasons.DeviationBlocked:
            return React.createElement(DeviationBlockedFullView, __assign({}, props));
        case BlockReasons.ArtistBlocked:
            return React.createElement(ArtistBlockedFullView, __assign({}, props));
        case BlockReasons.MatureFilter:
            return React.createElement(MatureBlockedFullView, __assign({}, props));
        case BlockReasons.MatureLoggedOut:
            return React.createElement(MatureAnonymousBlockedFullView, __assign({}, props));
        case BlockReasons.MatureAge:
            return React.createElement(MatureAgeBlockedFullView, __assign({}, props));
        case BlockReasons.StrictMatureAge:
            return React.createElement(MatureStrictBlockedFullView, __assign({}, props));
        case BlockReasons.Antisocial:
            return React.createElement(AntisocialBlockedFullView, __assign({}, props));
        case BlockReasons.BlockedByArtist:
        default:
            return React.createElement(DefaultBlockedFullView, __assign({}, props));
    }
};
BlockedFullView.displayName = 'BlockedFullView';
export default BlockedFullView;
//# sourceMappingURL=Hidden.js.map